module.exports = __webpack_public_path__ + "static/media/Jaime_Alberto_Cantu_Gonzalez.a74bd69e.png";